import MultiSelectReminderTitle from './MultiSelectReminderTitle';

export default MultiSelectReminderTitle;
